(function() {
  // --- Script 1: Automatisch eerste tab openen ---
  function quickOpen() {
    const firstTab = document.querySelector('.product-block--tab .collapsible-trigger');
    if (firstTab && firstTab.getAttribute('aria-expanded') === 'false') {
      firstTab.click();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', quickOpen);
  } else {
    quickOpen();
  }

  // --- Script 2: Tab Abandonment (Get it or regret it!) ---
  let originalTitle = document.title;
  const attentionMessage = "Get it or regret it!";

  window.addEventListener("blur", function() {
    // Sla de titel op het moment van verlaten op (voor het geval deze dynamisch is veranderd)
    originalTitle = document.title;
    document.title = attentionMessage;
  });

  window.addEventListener("focus", function() {
    document.title = originalTitle;
  });

})();